function legacyEncode(str) {
  return encodeURIComponent(str)
    .replace(/%3A/gi, ':')
    .replace(/%24/g, '$')
    .replace(/%2C/gi, ',')
    .replace(/%20/g, '+')
    .replace(/%5B/gi, '[')
    .replace(/%5D/gi, ']');
}

function isURLSearchParams(value) {
  return (
    typeof URLSearchParams !== 'undefined' && value instanceof URLSearchParams
  );
}

/**
 * Serialize params in legacy axios style.
 * This was removed in axios v0.28.0 and has been added here for backward compatibility.
 *
 * Usage: axios.create({ paramsSerializer: { serialize: legacyParamsSerializer } })
 *
 * See: https://github.com/axios/axios/pull/4734
 *
 * @param {Object} params
 * @returns {string}
 */
export function legacyParamsSerializer(params) {
  if (!params) {
    return '';
  }

  if (isURLSearchParams(params)) {
    return params.toString();
  }

  const parts = [];

  Object.keys(params).forEach((rawKey) => {
    let val = params[rawKey];
    if (val === null || typeof val === 'undefined') {
      return;
    }

    let key = rawKey;

    if (Array.isArray(val)) {
      key = key + '[]';
    } else {
      val = [val];
    }

    val.forEach((v) => {
      if (v === null || typeof v === 'undefined') {
        return;
      }
      if (v instanceof Date) {
        v = v.toISOString();
      } else if (v && typeof v === 'object') {
        v = JSON.stringify(v);
      }
      parts.push(legacyEncode(key) + '=' + legacyEncode(v));
    });
  });

  return parts.join('&');
}
